import axios from 'axios';
import api from '@/api';

const apiWithoutBearer = axios.create({
    baseURL: process.env.VUE_APP_API_URL + '/api/v1',
});


export const actions = {

    resetState({commit}) {
        commit('resetState')
    },

    commonStartLoading({commit}) {
        commit('commonStartLoading')
    },

    commonEndLoading({commit}) {
        commit('commonEndLoading')
    },

    toggleSidebar({commit}) {
        commit('toggleSidebar')
    },

    commonDownloadFile({commit}, data) {
        return new Promise((resolve, reject) => {
            commit('commonStartLoading');
            let dataRequest  = {
                method: data.method || 'get',
                url: data.url,
                responseType: 'arraybuffer'
            };
            if(data.data && data.method === 'post') {
                dataRequest.data = data.data;
            }
            const apiForDownload = data.auth ? api : apiWithoutBearer;

            apiForDownload(dataRequest)
                .then(resp => {
                    const url = window.URL.createObjectURL(new Blob([resp.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', data.filename);
                    document.body.appendChild(link);
                    link.click();
                    commit('commonEndLoading');
                    resolve(resp.data);
                })
                .catch((err) => {
                    commit('commonEndLoading');
                    reject(err)
                })
        });
    },

    commonGetNazioni({commit}) {
        return new Promise(() => {
            api({url: 'select/nazioni', method: 'POST'})
                .then(resp => {
                    commit('setNazioni', resp.data);

                })
                .catch()
        });
    },

    commonGetProvincie({commit}) {
        return new Promise(() => {
            api({url: 'select/provincie', method: 'POST'})
                .then(resp => {
                    commit('setProvincie', resp.data);
                })
                .catch()
        });
    },

    commonGetCitta({commit}) {
        return new Promise(() => {
            api({url: 'select/citta', method: 'POST'})
                .then(resp => {
                    commit('setCitta', resp.data);
                })
                .catch()
        });
    },

};
